import { render, staticRenderFns } from "./reference-rating-edit-part3.vue?vue&type=template&id=a086abd6&"
import script from "./reference-rating-edit-part3.vue?vue&type=script&lang=js&"
export * from "./reference-rating-edit-part3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports